import React from 'react';
import './Footer.css';  // Add your styles for the dashboard

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2025 MyAiWeb.ca. All Rights Reserved.
      <br></br>
       Email <a href="mailto:feedback@myaiweb.ca">feedback@myaiweb.ca</a></p>       
    </footer>
  );
};

export default Footer;
